module.exports = __webpack_public_path__ + "media/images/right-2be4f4fbf43e3244a217fe41c72cb277.png";